

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import USDT1 from './components/Usdt1'
import USDT2 from './components/Usdt2'
import USDT3 from './components/Usdt3'
import USDT4 from './components/Usdt4'
import USDT5 from './components/Usdt5'
import Deposit from './components/Deposit'
import Deposit1 from './components/Deposit1'
import Deposit2 from './components/Deposit2'
import Deposit3 from './components/Deposit3'
import Alipay from './components/Alipay'
import Bankcard from './components/Bankcard'
import DepositQrcode from './components/Qrcode'
import Finished from './components/Finished'
import Error from './components/Error'
import C2C from './components/C2C'
import axios from 'axios'
import i18n from '@/locales'

import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


Vue.use(AjaxPlugin)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(VueRouter)

const routes = [
{
path: '/',
component: Deposit
},
{
path: '/deposit1',
component: Deposit1
},
{
path: '/deposit2',
component: Deposit2
},
{
path: '/deposit3',
component: Deposit3
},
{
path: '/alipay',
component: Alipay
},
{
path: '/bankcard',
component: Bankcard
},
{
path: '/usdt1',
component: USDT1
},
{
path: '/usdt2',
component: USDT2
},
{
path: '/usdt3',
component: USDT3
},
{
path: '/usdt4',
component: USDT4
},
{
path: '/usdt5',
component: USDT5
},
{
path: '/qrcode',
name: 'deposit-qrcode',
component: DepositQrcode
},
{
path: '/finished',
name: 'finished',
component: Finished
},
{
path: '/error',
name: 'error',
component: Error
},
{
path: '/c2c',
name: 'c2c',
component: C2C
}
]

let mode
if (window.location.hash === '') {
mode = 'history'
} else {
mode = 'hash'
}

const router = new VueRouter({
routes,
mode: mode
})

FastClick.attach(document.body)

Vue.config.productionTip = false

axios.defaults.withCredentials = true

/* eslint-disable no-new */
new Vue({
router,
i18n,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js